import React from 'react'
import CustomTag from 'components/CustomTag'

const Status = ({ status }) => {
  let colorType
  let tagMessage
  if (status == 'PASS') {
    colorType = 'green'
    tagMessage = 'Pass'
  } else if (status == 'FAIL') {
    colorType = 'red'
    tagMessage = 'Fail'
  }

  return (
    <CustomTag
      colorType={colorType}
      message={tagMessage}
      bordered={false}
      padding={'15px'}
    />
  )
}

export default Status
